import axiosInstance from '@/ajax';

const request = config => axiosInstance(config).then(res => res.data.data);

/**
 * 查询PAD版本信息
 * @returns {*}
 */
export const getPadVersionList = () => request({
  url: '/admin/list-pad-version',
  method: 'get',
});

/**
 * 创建PAD版本信息
 * @param data
 * @returns {*}
 */
export const createPadVersion = data => request({
  url: '/admin/create-pad-version',
  method: 'post',
  data,
});